<template>
	<nuxt-link
		:id="blok.uuid"
		:to="`/${blok.full_slug}`"
		:aria-label="blok.content.title"
		class="flex w-full flex-col"
	>
		<div
			:style="{
				'background-image': `url(${blok.content.image?.filename || ''})`,
			}"
			class="relative h-80 w-full rounded border-0 bg-cover"
		>
			<span
				role="presentation"
				class="absolute inset-0 rounded bg-black/20"
			></span>

			<nuxt-picture
				class="absolute top-1/2 left-1/2 -translate-1/2"
				loading="lazy"
				:src="blok.content.logo?.filename"
				provider="storyblok"
				width="254"
				sizes="xs:100vw sm:64px md:64px lg:100vw xl:100vw 2xl:100vw"
				:alt="blok.content.logo?.alt"
			/>
		</div>

		<div class="mt-2">
			<p class="font-sans-caption font-bold">{{ blok.content.title }}</p>
		</div>

		<div>
			<p class="block font-sans text-base font-normal text-gray-500">
				{{ blok.content.short_description }}
			</p>
		</div>
	</nuxt-link>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

defineProps<{
	blok: ISbStoryData;
}>();
</script>
